export default "__VITE_ASSET__BmglrN_Y__"